import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import DefaultLayout from '@/layouts/Default.vue'
import VueGtm from '@gtm-support/vue2-gtm'
import VueFbCustomerChat from 'vue-fb-customer-chat'
import configuration from '@/config'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify.plugin'
import veeValidate from './plugins/vee-validate.plugin'
import vueGtag from './plugins/vue-gtag.plugin'
import vueCookies from './plugins/vue-cookies.plugin'
import wait from './plugins/vue-wait.plugin'
import auth from './plugins/auth.plugin'
import filter from './plugins/filter.plugin'
import liff from './plugins/liff.plugin'
import utils from './plugins/utils.plugin'
import { globalConfigDayjs } from './utils/dayjs'

globalConfigDayjs()

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#01BB00',
  confirmButtonText: 'ตกลง'
})

Vue.use(veeValidate)
Vue.use(vueGtag, router)
Vue.use(vueCookies)

Vue.use(auth)
Vue.use(filter)
Vue.use(liff)
Vue.use(utils)
Vue.use(VueGtm, {
  id: configuration.GOOGLE_TAG_ID,
  enabled: false,
  loadScript: true,
  vueRouter: router
})

Vue.use(VueFbCustomerChat, {
  page_id: configuration.LINE_AGENCY_FACEBOOK_PAGE_ID
})

Vue.component('default-layout', DefaultLayout)
Vue.component('no-sidebar-layout', () => import('@/layouts/NoSidebar.vue'))

Vue.directive('text-label', (el, binding) => {
  el.innerHTML = binding.value || '-'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  wait,
  render: (h) => h(App)
}).$mount('#app')
